import { ADICIONAR_FORMAS_PAGAMENTO_ENCOMENDA } from '../types'

export default function adicionarFormasPagamentoEncomenda (formasPagamento) {
  return {
    type: ADICIONAR_FORMAS_PAGAMENTO_ENCOMENDA,
    payload: formasPagamento
  }
}
